export const FIRST_PAGE = 1;
export const SECOND_PAGE = 2;
export const GAP_SIZE = 2;
export const GAP_TEXT = "...";
export const MAX_INDEXABLE_PAGES = 3;
